import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultLoadingIconComponent } from './default-loading-icon/default-loading-icon.component';
import { ToDatePipe } from './pipes/to-date.pipe';
import { LocaleDatePipe } from './pipes/locale-date.pipe';
import { ReadOnlyGridComponent } from './kendo/grid/dynamic/read-only-grid/read-only-grid.component';
import { PicklistFilterMenuComponent } from './kendo/grid/custom/filter-menu-component/filter-menu.component';
import { FormsModule } from '@angular/forms';
import { GridModule } from '@progress/kendo-angular-grid';
import { BytesToMbytesPipe } from './pipes/bytes-to-mbytes.pipe';
import { AppendPipe } from './pipes/append.pipe';


@NgModule({
  declarations: [
    DefaultLoadingIconComponent,
    ToDatePipe,
    LocaleDatePipe,
    ReadOnlyGridComponent,
    PicklistFilterMenuComponent,
    BytesToMbytesPipe,
    AppendPipe,
  ],
  imports: [
    CommonModule,
    GridModule,
    FormsModule
  ],
  providers: [],
  exports: [
    DefaultLoadingIconComponent,
    ToDatePipe,
    LocaleDatePipe,
    BytesToMbytesPipe,
    AppendPipe,
    ReadOnlyGridComponent,
  ]
})
export class SharedModule { }
